import React from 'react';
import { Route } from 'react-router-dom';

import { ADMIN_PRODUCTS_APP_PATHS } from '../constants/products-app-paths.constants';
import AdminProductsView from '../views/admin/AdminProducts.view';
import AdminProductDetailsView from '../views/admin/AdminProductDetails.view';

export default function AdminProductsRoutes() {
  return (
    <React.Fragment>
      <Route exact path={ADMIN_PRODUCTS_APP_PATHS.PRODUCTS_LIST} component={AdminProductsView} />
      <Route exact path={ADMIN_PRODUCTS_APP_PATHS.PRODUCT_DETAILS(':productId')} component={AdminProductDetailsView} />
    </React.Fragment>
  );
}
